"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageLayout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const useMeasure_1 = __importDefault(require("react-use/lib/useMeasure"));
const ArrowLeftFatIcon_1 = require("../../assets/icons/ArrowLeftFatIcon");
const Loader_1 = require("../loader/Loader");
const useWindowUtils_1 = require("../../hooks/useWindowUtils/useWindowUtils");
const PageLayoutStylesContextController_1 = require("../../context/pageLayoutStyles/pageLayoutStylesContextController/PageLayoutStylesContextController");
const Styled = __importStar(require("./PageLayout.styles"));
const PADDING_TOP_DESKTOP = 96;
const PADDING_BOTTOM_DESKTOP = 20;
const PADDING_LEFT_DESKTOP = 16;
const PADDING_RIGHT_DESKTOP = 16;
const PADDING_TOP_MOBILE = 30;
const PADDING_BOTTOM_MOBILE = 30;
const PageLayout = ({ renderContent, renderDetails, header, withBackButton, isLoading }) => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [headerRef, { height: headerHeight }] = (0, useMeasure_1.default)();
    const { isDesktopView } = (0, useWindowUtils_1.useWindowUtils)();
    const { onClick: onClickBackButton, visible: isBackButtonVisible = true, icon: backButtonIcon, } = typeof withBackButton === 'object' ? withBackButton : { onClick: undefined, visible: true, icon: undefined };
    const pageLayoutStylesProps = (0, react_1.useMemo)(() => ({
        headerHeight,
        paddingTop: isDesktopView ? PADDING_TOP_DESKTOP : PADDING_BOTTOM_DESKTOP,
        paddingBottom: isDesktopView ? PADDING_TOP_MOBILE : PADDING_BOTTOM_MOBILE,
        paddingRight: PADDING_RIGHT_DESKTOP,
        paddingLeft: PADDING_LEFT_DESKTOP,
    }), [headerHeight, isDesktopView]);
    return ((0, jsx_runtime_1.jsx)(PageLayoutStylesContextController_1.PageLayoutStylesContextController, { pageLayoutStyles: pageLayoutStylesProps, children: (0, jsx_runtime_1.jsxs)(Styled.Container, { children: [(0, jsx_runtime_1.jsxs)(Styled.PageContent, { paddingTop: pageLayoutStylesProps.paddingTop, paddingBottom: pageLayoutStylesProps.paddingBottom, paddingLeft: pageLayoutStylesProps.paddingLeft, paddingRight: pageLayoutStylesProps.paddingRight, children: [(0, jsx_runtime_1.jsxs)(Styled.HeaderWrapper, { ref: headerRef, children: [withBackButton && isBackButtonVisible && ((0, jsx_runtime_1.jsx)(Styled.BackIconButton, { "data-testid": "back-button", onClick: () => (onClickBackButton ? onClickBackButton(navigate) : navigate(-1)), children: backButtonIcon ? backButtonIcon : (0, jsx_runtime_1.jsx)(ArrowLeftFatIcon_1.ArrowLeftFatIcon, {}) })), (0, jsx_runtime_1.jsx)(Styled.Header, { variant: "h2", children: header })] }), isLoading ? (0, jsx_runtime_1.jsx)(Loader_1.Loader, {}) : renderContent(pageLayoutStylesProps)] }), renderDetails && renderDetails()] }) }));
};
exports.PageLayout = PageLayout;
